<template src= "./index.html"></template>

<script>
import Vue from 'vue'
import isEmpty from 'lodash/isEmpty'
import { parseISO, format } from 'date-fns'
import optionData from '@/optionData/data'
import {ko} from 'vuejs-datepicker/dist/locale'
import { Tag } from 'element-ui'
import moment from 'moment'
import agTableComp from '@/optionData/agTableComp'
export const BtnSelect = Vue.extend({
  name : 'btnSelect',
  template: `
      <vs-button class="btnSmall" @click="btnClickedHandler()" color="success" type="filled">선택</vs-button>
    `,
  data(){
    return{
      title : ''
    }
  },
  created(){
    this.title = this.params.colDef.headerName
    
  },
  methods: {
    btnClickedHandler() {
      this.params.clicked(this.params.data);
    }
  },
});
export default {
  name: 'transaction',
  
  data () {
    return {
      ko : ko,
      optionData : optionData,
      roleType : null,
      currency : null,
      type : null,
      typeOption : [
        {value : 'advance_payment', label:  '선급금 상계 -', },
        {value : 'withdrawal', label : '출금 -' },
        {value : 'settlement', label : '정산금 + ', },
        {value : 'admin_payment', label : '관리자 지급 +', },
        {value : 'admin_deduction', label : '관리자 차감 -'}
      ],
      keywordOption :[
          {value: 'email', label:'Email ID'},
          {value: '_name', label:'권리자명'},
          {value: 'company', label: '회사명'},
          {value: 'ref_code',label: '거래번호',},
          {value: '_ap_refcode',label: '선급계약코드',},
      ],
      keywordType :null,
      keyword : '',

      startDate :null,
      endDate : null,
      dateType :null ,
  
      dateOption : [
          {value: 'album_release_date',label: '발매일',},
          {value: 'contract_start_date',label: '계약시작일',},
      ],
      total : 0,
      page: {
          pageSize : 10,
          currentPage: 1,                       // 현재 페이지
          totalPage: 0,                         // 총 페이지수
      },          
      gridOptions :{ // 테이플 옵션
        
        context: {
          componentParent: this
        },
        frameworkComponents :agTableComp,
      },
      defaultColDef: {
          sortable: false,
          editable: false,
          resizable: true,
          suppressMenu: false,
          rowSelection:'single',
          suppressPaste: true
      },
      columnDefs: [
          // advancepayment_id: null
          // aggregator_display_name: null
          // amount: -100000
          // balance: 0
          // created_at: "2020-11-04T02:30:13.818Z"
          // description: null
          // id: 1470
          // processing_date: "2020-11-04"
          // ref_code: "T201104-452LFZV"
          // salesline_group_id: null
          // type: "withdrawal"
          // updated_at: "2020-11-04T02:30:13.818Z"
          // user_company: "주식회사 사운드리퍼블리카"
          // user_currency: "krw"
          // user_email: "dist_kr@soundrepublica.com"
          // user_family_name: null
          // user_given_name: "노건식, 김태윤"
          // user_id: 628
          // user_role: "licensor"
          // withdrawal_id: 9
          {headerName: '처리일시',      field: 'created_at',     filter: false,width: 170,
          cellRenderer: (data) => {
            return this.fixDate(data.value, 'yyyy-MM-dd HH:mm:ss')
          }},
          
          {headerName: '이메일',      field: 'user_email',     filter: false,width: 270},
          {headerName: '권리자명(성 이름)',      field: 'user_family_name',     filter: false,width: 200,
          cellRenderer: (data) => {
            
            return (data.data.user_family_name ? data.data.user_family_name  :'' )+' ' + (data.data.user_given_name ? data.data.user_given_name : '')
          }},
          
          {headerName: '회사명', field: 'user_company',     filter: false,width: 200},
          {headerName: '정산화폐', field: 'user_currency',     filter: false,width: 100, cellRenderer: (data) => {
            let dd = data.value.toUpperCase()
            return dd
          }},
          
          {headerName: '구분', field: 'type', filter: false,width: 170,
          cellRendererParams: {
            clicked: function(data) {
              this.context.componentParent.userExcel(data)
            }
          },
            
          cellRendererSelector: (data) => {
            let dd = {
              advance_payment : '선급금 상계', 
              withdrawal : '출금', 
              settlement : '정산금', 
              admin_payment : '관리자 지급', 
              admin_deduction : '관리자 차감'
            }
            let text = dd
            if(data.value == 'settlement'){
                return { 
                component: 'btnSelect',
                params: {
                  ...data.data,
                  title: '정산금 내역다운'
                }
              }
              
            }else if(data.value == 'advance_payment'){
              
              return { 
                component: 'textRender',
                params: {
                  ...data.data,
                  text:  dd[data.value] + ' - '+ data.data.advancepayment_ref_code
                }
              }
            }else{
              return { 
                component: 'textRender',
                params: {
                  ...data.data,
                  text:  dd[data.value]
                }
              }
            }
           
          }},
          
          {headerName: '금액', field: 'amount', filter: false,width: 200,cellRenderer: (data) => {
            let type = {
              advance_payment : '', 
              withdrawal : '', 
              settlement : '+', 
              admin_payment : '+', 
              admin_deduction : ''
            }
            
            let dd = {
              eur : ' €', 
              usd : ' $', 
              krw : ' 원', 
            }
            console.log(data.value < 0);
            if(data.data.user_currency == 'krw'){
              return `<span class=${ data.value < 0 ? 'blue' : 'red'}>`+  (data.value > 0 ? '+' : '') + this.numberFormat(data.value,'0') + dd[data.data.user_currency]+`</span>`;
            }else{
              return `<span class=${ data.value < 0 ? 'blue' : 'red'}>`+  (data.value > 0 ? '+' : '') + this.numberFormat(data.value)+ dd[data.data.user_currency]+`</span>`;
              
            }
          }},
          {headerName: '잔액',      field: 'balance',     filter: false,width: 200,cellRenderer: (data) => {
            let dd = {
              eur : ' €', 
              usd : ' $', 
              krw : ' 원', 
            }
            if(data.data.user_currency == 'krw'){
              return this.numberFormat(data.value,'0') + dd[data.data.user_currency];
            }else{
              return this.numberFormat(data.value) + dd[data.data.user_currency];
            }
          }},
          {headerName: '파트너사',      field: 'aggregator_display_name',     filter: false,width: 150},
          {headerName: '관리자용 메모',      field: 'description',     filter: false,width: 200},
          {headerName: '', field: 'type', filter: false,width: 100,
          cellRendererParams: {
            clicked: function(data) {
              this.context.componentParent.memoEditOpen(data)
            }
          },
          cellRendererSelector: (data) => {
            let type = {
              advance_payment : false, 
              withdrawal : false, 
              settlement : false, 
              admin_payment : true, 
              admin_deduction : true,
            }
            if(type[data.data.type]){
              return { 
              component: 'btnSelect',
                params: {
                  ...data.data,
                  title: '메모수정'
                }
              }
            }else{
              return { 
              component: 'textRender',
                params: {
                  ...data.data,
                  title : '',
                  text: ''
                }
              }
            }
            
           
          }},
          {headerName: '거래번호(T-No.)',      field: 'ref_code',     filter: false,width: 200},
      ],
      tableData:[
      ],   
      userList: {
        listData: [],                 
        pageSize: 10,                 
        currentPage: 1,
        totalPage: 0,                
      },
      licensorKeyword : null,
      // 라이센서 추가
      gridOptions5 :{ // 테이블 옵션 (같은 페이지에 있을때 공유해서 쓰면 에러)
        context: {
            componentParent: this
        },
        onGridReady: function (event) {
        },
        frameworkComponents : {
          btnSelect : BtnSelect
        }
      },
      columnDefsUser : [
        {headerName: '선택', field: '', filter: false,width: 130,
          cellRendererParams: {
            clicked: function(data) {
              this.context.componentParent.selectUser(data)
              //this.context.componentParent.closeModal('licensor')
            }
          },
          cellRendererSelector: (data) => {
            let dd 
            if(data.data.role == 'user' || data.data.role == 'admin'){
              dd = ''
              return null
            }else{
              dd = {
                component: 'btnSelect',
                params: data
              }
            }
            return dd
        }},
        {headerName: 'Role', field: 'role', filter: false,width: 120,},
        {headerName: 'E-mail ID', field: 'email', filter: false,width: 220,},
        {headerName: '권리자명 (성 이름)', field: 'licensor.family_name', filter: false,width: 150,
          cellRenderer: (data) => {
            let fm = '';
            let gm = '' ;
            if(data.data.role == 'licensor'){
              fm = data.data.licensor.family_name ? data.data.licensor.family_name : '';
              gm = data.data.licensor.given_name ? data.data.licensor.given_name : '' ;
            }else if(data.data.role == 'contractor'){
              fm = data.data.contractor.family_name ? data.data.contractor.family_name : '';
              gm = data.data.contractor.given_name ? data.data.contractor.given_name : '' ;
            }
            
            return fm +' '+ gm
        }},
        {headerName: '회사명', field: 'licensor.company', filter: false,width: 150,},
        {headerName: '정산화폐', field: 'licensor.currency', filter: false,width: 150,
          cellRenderer: (data) => {
            const type = {
                'krw' : 'KRW',
                'usd' : 'USD',
                'eur' : 'EUR',
            }
            return type[data.value]
        }},
        {headerName: '거주국가',  field: 'licensor.entity_address.country',  filter: false,width: 155,},
        {headerName: '등록일시',  field: 'created_at',  filter: false,width: 200,
        cellRenderer: (data) => {
          return this.fixDate(data.value, 'yyyy-MM-dd hh:mm:ss')
        }},
      ],
      keywordType : {value: '_name', label:'권리자명'},
      keywordType2 : {value: '_name', label:'권리자명'},
      licensorKeyword : '',
      memberOption : optionData.memberKeyword,
      userList: {
        listData: [],                 
        pageSize: 10,                 
        currentPage: 1,
        totalPage: 0,                
      },
      userSelected : false,
      userSelectedId : null,
      selectUserData : {},
      paymentData : {
        type : null,
        amount : 0,
        description : null,
      }, 
      paymentTypeOption:[
        { value : 'admin_payment', label : '지급' },
         {value : 'admin_deduction', label : '차감'}
      ],
      memoData : {
        user_email : null,
        amount : null, 
        description : null
      },

      withdrawalList : []
    }
  },
  created(){
      if(this.$route.query.page){
          this.page.currentPage= Number(this.$route.query.page)
      }
      if(this.$route.query.keywordType){
          this.keywordType= this.$route.query.keywordType
      }
      if(this.$route.query.keyword){
          this.keyword= this.$route.query.keyword
      }
      if(this.$route.query.type){
          this.type= this.$route.query.type
      }
      
      if(this.$route.query['date_start']) this.startDate = this.$route.query['date_start'] 
      if(this.$route.query['date_end']) this.endDate = this.$route.query['date_end'] 
  },
  mounted(){
    this.$nextTick(() =>{
      this.callList()
    })
  },
  computed: {
   
  },
  watch: {
    'page.currentPage'(e){
        
        this.callList()
    },
    'page.pageSize'(){
        this.list_search()
    },
    'userList.currentPage'(){
      this.getUserList()
    },
  },
  methods: {
    resetSearch (){
      this.page.currentPage = 1
      this.keyword = null
      this.keywordType = null
      this.startDate = null 
      this.endDate = null 
      this.state = null
      this.role = null
      this.currency = null
      this.entity = null
      this.payment_method = null
      this.callList() 
    },
    callList(){
        this.loadingShow();
        const option = {
            sort: 'id',
            sortorder: 'desc',
            page: this.page.currentPage-1 ,
            limit: this.page.pageSize,
            
        }
        let query = {}
        if(!this.valCheck(this.keywordType) && !this.valCheck(this.keyword)) {
            option[this.keywordType.value] = this.keyword
            query[this.keywordType.value] = this.keyword
        }
        if(!this.valCheck(this.startDate )&& !this.valCheck(this.endDate) ){
          option['date_start'] = this.startDate
          option['date_end'] = this.endDate
          query['date_start'] = this.startDate
          query['date_end'] = this.endDate
        }
        if(this.page.currentPage != 1){
          query['page'] = this.page.currentPage
        }
        if(this.roleType && this.roleType !='') {
            option['role'] = this.roleType
            query['roleType'] = this.roleType
        }
        if(!this.valCheck(this.type) ){
            option['type'] = this.type
            query['type'] = this.type
        }
        if(!this.valCheck(this.currency) ){
          option['currency'] = this.currency
          query['currency'] = this.currency
        }

        // if(this.roleType && this.roleType !='') {
        //     option['role'] = this.roleType.value
        // }
        // const param = {
        //     page: this.currentPage - 1,
        //     limit: this.pagingPerPage,
        //     sort: 'id',
        //     sortorder: 'desc',
            
        // }
        this.$router.replace({query: query}).catch((e)=>{});
        this.$store.dispatch('GET_TRANSACTION', option)
        .then(result =>{
            this.loadingHide();
            console.log(result)
            this.tableData  = result.items // 권리자 목록
            
            this.total = result.total // 총인원수 
            this.filtered = result.filtered // limit에 따른 수
            //페이지 수
            const remainder = parseInt(this.filtered % this.page.pageSize) > 0? 1: 0
            this.page.totalPage = parseInt(this.filtered/this.page.pageSize) + remainder
        }).catch(error=>{
           this.loadingHide();
          const status = error.status
          switch(status){
            case 401:
            this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
            break;
            default:
              this.alert({msg:error.response.data.message})
            break;
          }
        })
    },
    list_search(){
      this.page.currentPage = 1  // 초기화
      this.callList()
    },
    viewDetail(event){
        //this.$router.push('album/detail/'+event.data.album_id)
    },
    getUserList(){
      const option = {
        sort: 'created_at',
        sortorder: 'desc',
        //role : 'licensor',
        page: this.userList.currentPage-1 ,
        limit: this.userList.pageSize
      }
      if(this.keywordType2 && this.keywordType2 !='') {
          option[this.keywordType2.value] = this.licensorKeyword
      }
      this.loadingShow()
      this.$store.dispatch('GETUSER', option)
      .then(result =>{
          this.loadingHide()
          this.userList.listData  = result.items // 권리자 목록
          //페이지 수
          const remainder = parseInt(result.filtered % this.userList.pageSize) > 0? 1: 0
          this.userList.totalPage = parseInt(result.filtered /this.userList.pageSize) + remainder
      }).catch(error=>{
          this.loadingHide()
          const status = error.response.status
          switch(status){
            case 401:
            this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
            break;
            default:
              this.alert({msg : error.response.data.message})
            break;
          }
      })
    },
    openUser(){
      this.keywordType2 = {label:'권리자명', value:'_name'},
      this.selectUserData = {}
      this.userSelected = false
      this.userSelectedId = null
      this.licensorKeyword = ''
      this.withdrawalList = []
      this.paymentData = {
        type : null,
        amount : 0,
        description : null,
      }
      this.openModal('user')
      this.getUserList()
      
    },
    selectUser(data) {
      this.selectUserData = {
        ...data,
        ...data.licensor,
        ...data.contractor
      }
      this.userSelected = true 
      this.userSelectedId = data.id
      this.userWithdrawal(data)
    },
    prevStep(){
      this.keywordType = {label:'Email ID', value:'email'},
      this.selectUserData = {}
      this.userSelectedId = null
      this.userSelected = false
      this.licensorKeyword = ''
    },
    savePayment(){
      if(this.valCheck(this.userSelectedId)) {
        this.alert({msg : '권리자 선택이 제대로 되지 않았습니다.<br/> 처음부터 시도 해주세요.'})
        return false
      }
      if(this.valCheck(this.paymentData.type)) {
        this.alert({msg : '지급/차감 구분을 선택해주세요.'})
        return false
      }
      if(this.valCheck(this.paymentData.amount)) {
        this.alert({msg : '지급/차감액 을 입력해주세요.'})
        return false
      }
      const api1 = new Promise(resolve =>{  
        this.loadingShow();
        const option = {
          sort: 'created_at',
          sortorder: 'desc',
          page: 0 ,
          limit: 5,
          user_email : this.selectUserData.email
        }
        let query = {}
        this.$store.dispatch('GETWITHDRAWAL', option)
        .then(result =>{
          this.withdrawalList = result.items
          resolve(true)
        }).catch(error=>{
            const status = error.status
            this.loadingHide();
            resolve(false)
            switch(status){
              case 401:
              this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
              break;
              default:
                this.alert({msg:error.response.data.message})
              break;
            }
        })
      })
    
      Promise.all([api1])
      .then(result =>{
        let payload ={
          id : this.userSelectedId,
          params : this.paymentData
        }
        
        payload.params.amount = this.numberFilter(payload.params.amount)
        if(this.withdrawalList.length > 0 && this.withdrawalList[0].state =="requested" ){
          this.confirm({
            title : '관리자 지급/차감',
            msg : `
                현재 출금신청중인 권리자입니다. 그래도 관리자 지급/차감 진행하시겠습니까?
            `,
            action : ()=>{
              this.loadingShow()
                this.$store.dispatch("POST_TRANSACTION", payload)
                .then(result =>{
                    this.loadingHide()
                    this.callList()
                    this.noti('권리자 지급/차감이 처리었습니다.')
                    this.closeModal('user')
                }).catch(error=>{
                    this.loadingHide()
                    const status = error.response.status
                    switch(status){
                      case 401:
                      this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                      break;
                      default:
                        this.alert({msg : error.response.data.message})
                      break;
                    }
                })
            }
          })
        }else{
          this.loadingShow()
          this.$store.dispatch("POST_TRANSACTION", payload)
          .then(result =>{
              this.loadingHide()
              this.callList()
              this.noti('권리자 지급/차감이 처리었습니다.')
              this.closeModal('user')
          }).catch(error=>{
              this.loadingHide()
              const status = error.response.status
              switch(status){
                case 401:
                this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                break;
                default:
                  this.alert({msg : error.response.data.message})
                break;
              }
          })
        }
      })
      
      
    },
    getExcelFile(response){
      let filename = "",
          disposition = response.headers["content-disposition"];
        
      if (disposition && disposition.indexOf("attachment") !== -1) {
          let filenameRegex = /filename\*?=['"]?(?:UTF-\d['"]*)?([^;\r\n"']*)['"]?;?/, matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
          }
      }

      if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE variant
          window.navigator.msSaveOrOpenBlob(new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
              filename);
      } else {
          const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
      }
    },
    getExcel(){
      const option = {
      }
      let query = {}

      if(this.keywordType && !this.valCheck(this.keyword)) {
          option[this.keywordType.value] = this.keyword
      }

      if( !this.valCheck(this.startDate )&& !this.valCheck(this.endDate) ){
          option['date_start'] = this.startDate
          option['date_end'] = this.endDate
      }
      
      if(this.roleType && this.roleType !='') {
          option['role'] = this.roleType
      }

      if(!this.valCheck(this.type) ){
          option['type'] = this.type
      }

      if(!this.valCheck(this.currency) ){
        option['currency'] = this.currency
      }

      if(Object.keys(option).length < 3){
        this.alert({msg:'기간 외에 한가지 이상의 검색 조건을 입력해주세요.'});
        return false;
      }

      this.loadingShow();
      
      this.$store.dispatch('GET_TRANSACTION_EXCEL', option)
      .then(result =>{
          this.loadingHide();
          console.log('result',result)
          this.getExcelFile(result)
      }).catch(error=>{
        const status = error.status
        switch(status){
          case 401:
          this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
          break;
          default:
            this.alert({msg:error.response.data.message})
          break;
        }
      })
    },
    userExcel(option){
      this.loadingShow();
      this.$store.dispatch('GET_USER_TRANSACTION_EXCEL', option)
        .then(result =>{
            this.loadingHide();
            console.log('result',result)
            this.getExcelFile(result)
        }).catch(error=>{
          const status = error.status
          switch(status){
            case 401:
            this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
            break;
            default:
              this.alert({msg:error.response.data.message})
            break;
          }
      })
    },
    memoEditOpen(data){
      this.memoData = {...data}
      console.log(data)
      this.openModal('memo')

      let dd = {
        advance_payment : '선급금 상계', 
        withdrawal : '출금', 
        settlement : '정산금', 
        admin_payment : '관리자 지급', 
        admin_deduction : '관리자 차감'
      }
      let text = dd[this.memoData.type]
      this.memoData.type = text
      
      let price = {
        eur : ' €', 
        usd : ' $', 
        krw : ' 원', 
      }
      let amount = null 
      if(data.user_currency == 'krw'){
        amount =  `<span class=${ data.amount < 0 ? 'blue' : 'red'}>`+  (data.amount > 0 ? '+' : '') + this.numberFormat(data.amount,'0') + price[data.user_currency]+`</span>`;
        this.memoData.balance =   this.numberFormat(data.balance,'0') + ''  + price[data.user_currency]
      }else{
        amount = `<span class=${ data.amount < 0 ? 'blue' : 'red'}>`+  (data.amount > 0 ? '+' : '') + this.numberFormat(data.amount)+ price[data.user_currency]+`</span>`;
        this.memoData.balance =   this.numberFormat(data.balance) + '' + price[data.user_currency]
      }
      console.log(amount)
      this.memoData.amount = amount
      this.memoData.user_name = (data.user_family_name ? data.user_family_name  :'' )+' ' + (data.user_given_name ? data.user_given_name : '')
    },
    memoEditPost(){
      this.confirm({
        title : '메모 수정 확인',
        msg : `
          선택하신 메모를 수정하시겠습니까?
        `,
        autofocus : true,
        width:400,
        action : ()=>{
          let payload = {
            id : this.memoData.id,
            params : {
              description : this.memoData.description ? this.memoData.description : null
            }
          }
          this.loadingShow()
           this.$store.dispatch('PUT_TRANSACTION_MEMO', payload)
          .then(result =>{
              this.closeModal('memo')
              this.callList()
              this.loadingHide();
          }).catch(error=>{
            this.loadingHide();
            const status = error.status
            switch(status){
              case 401:
              this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
              break;
              default:
                this.alert({msg:error.response.data.message})
              break;
            }
        })
        }
    })
      
    },
    userWithdrawal(data){
        this.loadingShow();
        const option = {
          sort: 'created_at',
          sortorder: 'desc',
          page: 0 ,
          limit: 5,
          user_email : data.email
        }
        let query = {}
        this.loadingShow();
        this.$store.dispatch('GETWITHDRAWAL', option)
        .then(result =>{
          this.loadingHide();
          this.withdrawalList = result.items
        }).catch(error=>{
            const status = error.status
            this.loadingHide();
            
            switch(status){
              case 401:
              this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
              break;
              default:
                this.alert({msg:error.response.data.message})
              break;
            }
        })
    },
  }
}
</script>

<style scoped>

</style>
